// extracted by mini-css-extract-plugin
export default {"title":"styles_title__0B6E4","paragraph":"styles_paragraph__g948o","label":"styles_label__v1SnB"};